import { authAdapter } from '@/app/_auth/auth'
import { useAuth } from '@/app/_auth/auth-hooks'
import { AuthStep } from '@/app/_auth/auth-step-navigator'
import { AuthStepTemplate } from '@/app/_auth/steps/_common/auth-step-template'
import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/toaster'
import { useReactivateAccountMutation } from '@/hooks/api/use-reactivate-account-mutation'
import { T, useTranslate } from '@tolgee/react'

export function DeactivatedStep() {
  const { t } = useTranslate()
  const { user, setStep } = useAuth()
  const { isPending, mutate } = useReactivateAccountMutation({
    onSuccess: () => setStep(AuthStep.GetSessionData),
    onError: (e) => {
      console.error(e)
      toast.error('Failed to reactivate account')
      setStep(AuthStep.Create)
    },
  })

  const deactivatedDate = user?.lastUpdatedAt
    ? new Date(parseInt(user.lastUpdatedAt + '000'))
    : new Date()

  return (
    <AuthStepTemplate>
      <AuthStepTemplate.Header>
        <AuthStepTemplate.H1
          className='max-w-[360px]'
          keyName='auth.steps.deactivated.title'
          params={{
            date: deactivatedDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            }),
          }}
        />
        <AuthStepTemplate.H3 keyName='auth.steps.deactivated.p1' />
        <AuthStepTemplate.H3 keyName='auth.steps.deactivated.p2' />
      </AuthStepTemplate.Header>
      <AuthStepTemplate.ButtonRow>
        <Button
          variant='mango-outline'
          shape='square'
          size='sm'
          title={t('auth.steps.deactivated.signOutButton.a11y')}
          className='w-full'
          onClick={() => {
            if (authAdapter) {
              authAdapter.signOut().catch((err) => {
                console.error('Failed to sign out:', err)
              })
            }
          }}
          disabled={isPending}
        >
          <T keyName='auth.steps.deactivated.signOutButton.title' />
        </Button>
        <Button
          shape='square'
          size='sm'
          title={t('auth.steps.deactivated.reactivateButton.a11y')}
          className='w-full'
          onClick={() => mutate()}
          loading={isPending}
        >
          <T keyName='auth.steps.deactivated.reactivateButton.title' />
        </Button>
      </AuthStepTemplate.ButtonRow>
    </AuthStepTemplate>
  )
}
